import React, { useEffect, useState } from 'react';
import SideMenu from '../components/SideMenu';
import Header from '../components/Header';
import UserMenu from '../components/UserMenu';
import thumbimg from '../assets/images/thumbimg.png'
import TokenRegistrationTable from '../components/TokenRegistrationTable';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, FormControlLabel, TextField, Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import axios from 'axios';
import API_BASE_URL from '../utilities/ApiConfig';
import ApiLoader from '../components/ApiLoader';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { interpretPcode } from '../utilities/interpretPcode';
import formatDateTime from '../utilities/formatDateTime';

const PrintDoc = () => {
  const [loading, setLoading] = useState(false);
  const [bookMasterData, setBookMasterData] = useState([]);
  const [registrationYearMasterData, setRegistrationYearMasterData] = useState([]);
  const [scanningPropertyRegistrationList, setScanningPropertyRegistrationList] = useState([]);

  const [selectedBookNo, setSelectedBookNo] = useState('');
  const [selectedRegYear, setSelectedRegYear] = useState('');
  const [registrationNo, setRegistrationNo] = useState('');



  const { userDetails } = useSelector((state) => state.auth);
  console.log('user details', userDetails);
  const handleGetBookNoData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/Master/book_no_master_data_get`);
      console.log('book master api response data', response.data);
      if (response.data?.statusResponse?.statusCode === 200) {
        setBookMasterData(response.data?.bookMasterList);
      }
      else {
        toast.error(response.data?.statusResponse?.status);
      }
    } catch (error) {
      console.log('book no api error', error);
      toast.error('An Unexpected Error Occured Please try Again');
    } finally {
      setLoading(false);
    }
  }

  const handleGetRegistrationYearData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/Master/reg_year_master_data_get`);
      console.log('registration year api response data', response.data);
      if (response.data?.statusResponse?.statusCode === 200) {
        setRegistrationYearMasterData(response.data?.registrationYearMaster);
      }
      else {
        toast.error(response.data?.statusResponse?.status);
      }
    } catch (error) {
      console.log('registration year api error', error);
      toast.error('An Unexpected Error Occured Please try Again');
    } finally {
      setLoading(false);
    }
  }

  const handleGetScanningPropertyDetails = async () => {
    if (selectedBookNo.trim() !== '' && selectedRegYear.trim() !== '' && !isNaN(registrationNo) && registrationNo.trim() !== '') {

      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/Registration/get_scanning_data_using_dcode_srocode_bookno_regno_regyear?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&bookno=${selectedBookNo}&regyear=${selectedRegYear}&regno=${registrationNo}`)
        console.log('scanning api response data', response.data);
        if (response.data?.statusResponse?.statusCode === 200) {
          setScanningPropertyRegistrationList(response.data?.scanningPropertyRegistrationList)
        } else {
          toast.error(response.data?.statusResponse?.status);
          setScanningPropertyRegistrationList([]);
        }

      } catch (error) {
        console.log('Scanning data api error', error);
        toast.error('Failed to get Data due to unexpected error Please try Again');
      } finally {
        setLoading(false);
      }

    } else {
      toast.error('Please fill in all fields correctly.');
    }
  }

  useEffect(() => {
    handleGetBookNoData();
    handleGetRegistrationYearData();
  }, [])

  return (
    <>
      {loading && <ApiLoader />}

      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 p-4">
              <div className="flex flex-col items-center p-6 bg-gray-100 min-h-screen">
                {/* Top section with dropdowns and buttons */}
                <div className="w-full max-w-3xl flex justify-between items-center mb-6">
                  <select onChange={(e) => { setSelectedBookNo(e.target.value) }} className="border border-gray-300 rounded px-3 py-2" defaultValue="">
                    <option value="" disabled>Select Bookno.</option>
                    {bookMasterData.length > 0 && (bookMasterData.map((items, index) => <option key={index} value={items.bookNo}>{items.bookNo}</option>))}
                  </select>

                  <select onChange={(e) => { setSelectedRegYear(e.target.value) }} className="border border-gray-300 rounded px-3 py-2" defaultValue="">
                    <option value="" disabled>Select Regyear</option>
                    {registrationYearMasterData.length > 0 && (registrationYearMasterData.map((items, index) => <option key={index} value={items.regYear}>{items.regYear}</option>))}
                  </select>

                  <p>Regno:</p>
                  <input
                    type="number"
                    name='registrationNo'
                    value={registrationNo}
                    onChange={(e) => { setRegistrationNo(e.target.value) }}
                    placeholder="Input"
                    className="border border-gray-300 rounded px-3 py-1"
                  />
                  <button className="bg-blue-500 text-white rounded px-4 py-1" onClick={handleGetScanningPropertyDetails}>Okay</button>
                  <button className="bg-blue-500 text-white rounded px-4 py-1">Cancel</button>
                </div>

                {scanningPropertyRegistrationList.length > 0 &&
                  <div className="w-full max-w-3xl bg-white rounded shadow-md p-6">
                    <div className="grid grid-cols-2 gap-8 text-left">
                      {/* Left Column */}
                      <div className="space-y-4">
                        <div className="flex p-1 ">
                          <p className="w-40 font-semibold">Registration Date:</p>
                          <span className="">{formatDateTime(scanningPropertyRegistrationList[0]?.regDate)}</span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">Market Value:</p>
                          <span className="">{scanningPropertyRegistrationList[0]?.mValue}</span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">Transaction Value:</p>
                          <span className="">{scanningPropertyRegistrationList[0]?.transValue}</span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">Pages:</p>
                          <span className="">{scanningPropertyRegistrationList[0]?.page}</span>
                        </div>
                        <div className="flex p-1">
                          <p className="w-40 font-semibold">E.P. Fee:</p>
                          <span className="">{scanningPropertyRegistrationList[0]?.pasting}</span>
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4">

                        {scanningPropertyRegistrationList.length > 0 && (scanningPropertyRegistrationList.map((items, index) =>
                          <div key={index} className="flex p-1">
                            <p className="w-40 font-semibold">{interpretPcode(items.pcode)} </p>
                            <span className=""> {items.nameEng} </span>
                          </div>
                        ))}



                      </div>
                    </div>
                  </div>
                }


              </div>
            </div>


            {/* Right Side */}
            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PrintDoc
